import { useEffect, useState } from "react";
import { PrefersReducedMotionContextType } from "./prefersReducedMotion.types";
import PrefersReducedMotionContext from "./prefersReducedMotion.context";
import { useReducedMotion } from "motion/react";
import { useVideoSettings } from "../videoSettings/videoSettings.hook";

export const PrefersReducedMotionProvider = ({ children }) => {
  const reducedMotion = useReducedMotion();
  const [prefersReducedMotion, setPrefersReducedMotion] =
    useState<boolean>(reducedMotion);
  const { setIsPlayingIntroVideo } = useVideoSettings();

  const value: PrefersReducedMotionContextType = {
    prefersReducedMotion,
    setPrefersReducedMotion,
  };

  useEffect(() => {
    if (prefersReducedMotion) {
      setIsPlayingIntroVideo(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefersReducedMotion]);

  useEffect(() => {
    const detectBatterySavingMode = async () => {
      if ("getBattery" in navigator) {
        try {
          const battery = await (navigator as any).getBattery();
          if (!battery.charging && battery.level < 0.2) {
            setPrefersReducedMotion(true);
          }
        } catch (error) {
          console.warn("Battery API not accessible:", error);
        }
      }
    };

    detectBatterySavingMode();
  }, []);

  return (
    <PrefersReducedMotionContext.Provider value={value}>
      {children}
    </PrefersReducedMotionContext.Provider>
  );
};
